import { DocumentResource } from '~domains/partner-application/entities/application';

import { checkIsImageByFileName } from '~shared/lib/check-is-image';
import { FilePreview } from '~shared/ui/file-preview';

import { Typography } from '@breezeventures/ui-kit/typography';

type DocumentReviewItemProps = {
  title: string;
  document: DocumentResource;
};

export const DocumentReviewItem = ({
  document,
  title,
}: DocumentReviewItemProps) => {
  return (
    <div key={document.documentId} className="flex items-center gap-4">
      <FilePreview
        isImage={checkIsImageByFileName(document.fileName)}
        previewUrl={document.fileUrl}
      />
      <div className="flex min-w-0 flex-col">
        <Typography.Text size="s" tag="div">
          {title}
        </Typography.Text>
        <Typography.Text
          size="xs"
          color="secondary"
          className={`line-clamp-1 text-ellipsis`}
        >
          {document.fileName}
        </Typography.Text>
      </div>
    </div>
  );
};
